/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React, { useState } from 'react';
import './teacherItem.scss';

export default function TeacherItem(props) {
  const [flipped, setFlipped] = useState(false)

  return (
    <div className="sub-item">
      <div
        // onMouseEnter={() => setFlipped(!flipped)} 
        // onMouseLeave={() => setFlipped(!flipped)} 
        className={"card-container" + (flipped ? " flipped" : "")}>

        <div className="front">
          <div className="image-container">
            <img src={process.env.PUBLIC_URL + "/assets/images/" + props.imgName + ".avif"} alt=''/>
          </div>
        </div>

        <div className="back">
          <p>{props.des}</p>
        </div>
      </div>
    </div>
  )
}




